module.exports = {
      id: "business-usage",
      viewBox: "0 0 28.79 24.369",
      url: "/" + "sprite-4add775381efce29ef76f223dff77c00.svg#business",
      toString: function () {
        return this.url;
      }
    }